import Vue from "vue";
import Vuex from "vuex";
import { $api, setProp, deleteProp } from 'bh-mod'
import moment from "moment";

Vue.use(Vuex);

export default {
	state: {
		selectedWorkflow: null,
		workflows: [],
		totalWorkflows: 0,
		archivedWorkflows: [],
		totalArchivedWorkflows: 0,
		allSettings: {},
		loadingPage: false,
		getStarted: false,
		leadTags: [],
		sentimentOptions: [],
		taskType: [],
		emailTemplates: [],
		crmEmailTemplates: [],
		crmAppSettings: {},
		userCRMAppSettings: {},
		senders: [],
		forms: [],
		users: [],
		aiAgents: [],
		showWorkflowBuilder: false,
		multipleImages: false,
		activePhoneNumbers: [],
		smsWalletDetails: {},
		smsAppSettings: {},
	},
	mutations: {
		SET_SHOW_WORKFLOW_BUILDER(state, data = true) {
			state.showWorkflowBuilder = data
		},
		SET_WORKFLOW(state, data) {
			state.selectedWorkflow = data || null
		},
		SET_SETTINGS(state, data) {
			let temp = data;
			if (data.userApp == null) {
				temp.userApp = {
					options: {
						seenIntro: false,
					},
				};
				state.allSettings = temp;
			} else {
				state.allSettings = data;
			}
		},
		SET_WORKFLOWS(state, data) {
			state.workflows = data
		},
		SET_WORKFLOW_COUNT(state, data) {
			state.totalWorkflows = data
		},
		SET_ARCHIVED_WORKFLOWS(state, data) {
			state.archivedWorkflows = data
		},
		SET_ARCHIVED_WORKFLOW_COUNT(state, data) {
			state.totalArchivedWorkflows = data
		},
		SET_LEAD_TAGS(state, data) {
			state.leadTags = data || [];
		},
		SET_SENTIMENT_OPTIONS(state, data) {
			const result = data || [
				{ name: 'Next Step Booked', id: 'Next Step Booked' },
				{ name: 'Bad Timing', id: 'Bad Timing' },
				{ name: 'Not Interested', id: 'Not Interested' },
				{ name: 'No Fit', id: 'No Fit' },
			];
			state.sentimentOptions = result.map(r => { return { label: r.name, value: r.id } })
		},
		SET_TASK_TYPES(state, data) {
			state.taskTypes = data || [];
		},
		SET_CRM_TEMPLATE_LIST(state, data) {
			state.crmEmailTemplates = data || []
		},
		SET_CRM_APP_SETTINGS(state, data) {
			state.crmAppSettings = data || {}
		},
		SET_USER_CRM_APP_SETTINGS(state, data) {
			state.userCRMAppSettings = data || {}
		},
		SET_EMAIL_TEMPLATE(state, data) {
			state.emailTemplates = data || [];
		},
		SET_SENDERS(state, data) {
			state.senders = data || [];
		},
		SET_FORMS(state, data) {
			data.sort((a, b) => moment(b.updatedAt).format('x') - moment(a.updatedAt).format('x'))
			state.forms = data || [];
		},
		SET_AI_AGENTS(state, data) {
			state.aiAgents = data || [];
		},
		SET_USERS(state, data) {
			state.users = data.map(d => d.user) || [];
		},
		SET_APPDATA(state, data) {
			if (!data) data = {};
		},
		GET_STARTED: (state) => {
			state.getStarted = true;
		},
		LOAD_PAGE: (state, status = !state.loadingPage) => state.loadingPage = status,
		SET_PROP: (state, { where, what, del = false }) => {
			if (!where.length) return;
			if (del) return deleteProp(state, where);

			if (what.tags && what.tags.length) {
				what.tags = what.tags.map((x) => {
					if (!state.tags[x.id] && typeof x === "object")
						setProp(state, ["tags", x.id], x);
					return x.id;
				});
			}

			setProp(state, where, what);
		},

		SET_MULTIPLE_IMAGES(state, data) {
			state.multipleImages = data
		},

		SET_ACTIVE_PHONE_NUMBERS(state, data) {
			state.activePhoneNumbers = data.map(p => {
				const isTollFreeNumber = p.phoneNumberType === 'tollFree';
				const isTollFreeNumberVerified = p.metadata?.tollfreeVerification?.submissionStatus === 'twilio_approved';
				return {
					...p,
					isTollFree: Boolean(isTollFreeNumber),
					isTollFreeVerified: Boolean(isTollFreeNumberVerified),
				}
			})
		},

		SET_SMS_WALLET_DETAILS(state, data) {
			state.smsWalletDetails = data
		},

		SET_SMS_APP_SETTINGS(state, data) {
			state.smsAppSettings = data || {}
		},
	},
	actions: {
		SET_APPDATA: ({ commit, dispatch }, data) => {
			commit("SET_APPDATA", data)

			dispatch('FETCH_APPS_DATA');
			dispatch('FETCH_CRM_APP_SETTINGS');
			dispatch('FETCH_SMS_APP_SETTINGS');
			dispatch('FETCH_USER_CRM_APP_SETTINGS');
		},

		FETCH_APPS_DATA: async ({ dispatch, rootGetters }) => {
			dispatch('FETCH_LEAD_TAGS');
			dispatch('FETCH_EMAIL_TEMPLATE');
			dispatch('FETCH_SENDERS');
			dispatch('FETCH_FORMS');
			dispatch('FETCH_USERS');
			if (rootGetters.isAIEnabled) {
				dispatch('FETCH_AI_AGENTS');
			}
		},

		async FETCH_WORKFLOW({ commit }, workflowId) {
			try {
				const { data } = await $api.get(`/marketing-workflows/:instance/${workflowId}`);
				commit('SET_WORKFLOW', data)
			} catch (error) {
				console.error('Error occurred while fetching workflow details', error)
			}
		},

		async FETCH_LEAD_TAGS({ commit }) {
			try {
				const { data } = await $api.get(`/tags/:instance?type=contacts`);
				commit('SET_LEAD_TAGS', data)
			} catch (error) {
				console.error('Error occurred while fetching lead tags', error)
			}
		},

		async FETCH_CRM_APP_SETTINGS({ commit }) {
			try {
				const { data } = await $api.get(`/settings/:instance/contacts`);
				commit('SET_CRM_APP_SETTINGS', data)

				const taskTypes = data?.options?.taskType?.length ? data.options.taskType : [
					{ name: 'To-do', id: 'todo' },
					{ name: 'Call', id: 'call' },
					{ name: 'Follow up', id: 'followup' }
				];

				commit('SET_TASK_TYPES', taskTypes)
				commit('SET_CRM_TEMPLATE_LIST', data?.options?.templateList)
				commit('SET_SENTIMENT_OPTIONS', data?.options?.sentimentOptions)
			} catch (error) {
				console.error('Error occurred while fetching crm task types', error)
			}
		},

		async FETCH_SMS_APP_SETTINGS({ commit }) {
			try {
				const { data } = await $api.get(`/settings/:instance/sms`);
				commit('SET_SMS_APP_SETTINGS', data?.options)
			} catch (error) {
				console.error('Error occurred while fetching sms app settings', error)
			}
		},
		async FETCH_USER_CRM_APP_SETTINGS({ commit, rootState }, userID) {
			try {
				const userId = userID || rootState.user.user.id;
				const { data } = await $api.get(`/settings/:instance/${userId}/contacts`);
				commit('SET_USER_CRM_APP_SETTINGS', data)
			} catch (error) {
				console.error('Error occurred while fetching user crm app setting', error)
			}
		},

		async FETCH_EMAIL_TEMPLATE({ commit }) {
			try {
				const { data } = await $api.get(`/projects/:instance?type=email&default=true&_sort=updatedAt:DESC`);
				commit('SET_EMAIL_TEMPLATE', data)
			} catch (error) {
				console.error('Error occurred while fetching email template list', error)
			}
		},

		async FETCH_SENDERS({ commit }) {
			try {
				const { data } = await $api.get(`/senders/:instance?active=true`);
				commit('SET_SENDERS', data)
			} catch (error) {
				console.error('Error occurred while fetching sender list', error)
			}
		},

		async FETCH_FORMS({ commit, rootState }) {
			try {
				const { data } = await $api.get(`/forms/:instance?type_ne=worksheet&includeParent=true`);
				const forms = data.map(form => {
					if (form.instanceData && form.instanceData.id !== rootState.instance.id) {
						const projectType = Vue.prototype.$capitalize(form.instanceData.projectType)
						form.label = form.name + ` (${projectType}:${form.instanceData.name})`
					} else {
						form.label = form.name
					}
					return form
				})
				commit('SET_FORMS', forms)
			} catch (error) {
				console.error('Error occurred while fetching form list', error)
			}
		},

		async FETCH_USERS({ commit }) {
			try {
				const { data } = await $api.get(`instances/:instance/users`);
				commit('SET_USERS', data.users)
			} catch (error) {
				console.error('Error occurred while fetching user list', error)
			}
		},

		async FETCH_AI_AGENTS({ commit, rootGetters }) {
			if (!rootGetters.isAIEnabled) return;
			try {
				const { data } = await $api.get(`/ai-agents/:instance`, {
					params: {
						active: true,
						_limit: -1,
						_sort: 'updatedAt:DESC',
					}
				});
				commit('SET_AI_AGENTS', data)
			} catch (error) {
				console.error('Error occurred while fetching ai agent list', error)
			}
		},

		FETCH_ACTIVE_PHONE_NUMBERS: async ({ commit }) => {
			try {
				const { data } = await $api.get('/sending-phone-numbers/:instance')
				commit('SET_ACTIVE_PHONE_NUMBERS', data)
			} catch (error) {
				console.error('Error while fetching active phone numbers. Please try again!', error)
			}
		},

		FETCH_SMS_WALLET_DETAILS: async ({ commit }) => {
			try {
				const { data } = await $api.get('/wallets/:instance')
				commit('SET_SMS_WALLET_DETAILS', data)
			} catch (error) {
				console.error('Error while fetching SMS wallet balance. Please try again!', error)
			}
		}
	},
	getters: {
		emailTemplateObj(state) {
			let obj = {};
			state.emailTemplates.forEach((template) => {
				obj[template.id] = { ...template }
			})
			return obj
		},
		crmTemplateObj(state) {
			let obj = {};
			state.crmEmailTemplates.forEach((template) => {
				obj[template.createdAt] = { ...template }
			})
			return obj
		}
	},
};
